/** PosSaleType.Cash — cash tip rows must never enter Stripe payout math. */
export const POS_SALE_TYPE_CASH = 2;

/**
 * True when a tip-history / tip-transfer row is tied to a cash sale.
 */
export function isCashTipTransfer(transfer) {
    if (!transfer) return false;

    const paymentType = transfer.SalePaymentType ?? transfer.salePaymentType;
    if (paymentType === POS_SALE_TYPE_CASH || paymentType === '2') {
        return true;
    }
    if (typeof paymentType === 'string' && paymentType.toLowerCase() === 'cash') {
        return true;
    }

    return false;
}

/**
 * Strip cash-sale tip transfer rows from payout status / action calculations.
 */
export function excludeCashTipTransfers(transfers) {
    if (!Array.isArray(transfers)) {
        return [];
    }
    return transfers.filter((transfer) => !isCashTipTransfer(transfer));
}
